import React, { useEffect, useRef } from 'react';

export const SponsorBanner = ({
    mode = "image", // "image" or "iframe"
    image,
    url,
    alt = "Sponsor Banner",
    css_classes = "d-flex justify-content-center align-items-center pb-4 pt-4",
    iframeDesktopUrl,
    iframeMobileUrl,
    sponsorName = "sponsor",
}) => {
    const wrapperRef = useRef(null);
    const iframeRef = useRef(null);

    useEffect(() => {
        if (mode !== "iframe") return;

        const style = document.createElement("style");
        style.textContent = `
          .sponsor-banner-flex {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            margin-bottom: 1.5rem;
            margin-top: 1.5rem;
          }
          #sponsor-banner {
            position: relative;
            background: transparent;
            margin: 0 auto;
          }
          #banner-frame {
            position: absolute;
            width: 100%;
            height: 100%;
            border: none;
            top: 0;
            left: 0;
          }
        `;
        document.head.appendChild(style);
        return () => {
            document.head.removeChild(style);
        };
    }, [mode]);

    useEffect(() => {
        if (mode !== "iframe") return;

        function updateBanner() {
            if (!wrapperRef.current || !iframeRef.current) return;
            const containerWidth = window.innerWidth;
            const isMobile = containerWidth < 768;
            if (isMobile) {
                wrapperRef.current.style.width = "320px";
                wrapperRef.current.style.height = "320px";
                wrapperRef.current.style.aspectRatio = "";
            } else {
                wrapperRef.current.style.width = "100%";
                wrapperRef.current.style.maxWidth = "930px";
                wrapperRef.current.style.height = "";
                wrapperRef.current.style.aspectRatio = "31 / 6";
            }
            const url = isMobile ? iframeMobileUrl : iframeDesktopUrl;
            iframeRef.current.src = url;
        }
        updateBanner();
        window.addEventListener("resize", updateBanner);
        return () => window.removeEventListener("resize", updateBanner);
    }, [mode, iframeDesktopUrl, iframeMobileUrl]);

    if (mode === "iframe") {
        return (
            <div className="sponsor-banner-flex">
                <div
                    ref={wrapperRef}
                    id="sponsor-banner"
                >
                    <iframe
                        ref={iframeRef}
                        id="banner-frame"
                        src=""
                        title={`${sponsorName} sponsor banner`}
                    />
                </div>
            </div>
        );
    }

    return (
        <div className={css_classes}>
            <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="ad_sponsor_banner_link"
            >
                <img
                    src={image}
                    alt={alt}
                    className="ad_sponsor_banner_image"
                    style={{ maxWidth: "100%", height: "auto" }}
                />
            </a>
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/c/SponsorBanner.js